import { Box, Typography } from '@mui/material';

import { FORTA_GRAY4 } from '../../../../../../../utils/colors';

function FortaRepresentative() {
  return (
    <Box sx={{ width: '50%', textAlign: 'left', my: 4 }}>
      <Box>
        <Typography sx={{ color: FORTA_GRAY4, px: 1.5, mb: 1, fontWeight: 'bold' }}>
          Edan Morag
        </Typography>
        <Box sx={{ height: '1px', backgroundColor: 'black', width: '100%' }}></Box>
        <Typography>Representative Name</Typography>
      </Box>
      <Box sx={{ mt: 4 }}>
        <Typography sx={{ color: FORTA_GRAY4, px: 1.5, mb: 1, fontWeight: 'bold' }}>
          Forta Representative
        </Typography>
        <Box sx={{ height: '1px', backgroundColor: 'black', width: '100%' }}></Box>
        <Typography>Title</Typography>
      </Box>
    </Box>
  );
}

export default FortaRepresentative;
